/**
 * Copy text to the clipboard, returning whether it worked.
 *
 * navigator.clipboard is undefined outside a secure context (plain-http
 * staging, LAN testing on a phone), which is exactly where people try the
 * share flow — so fall back to the execCommand approach rather than failing.
 */
export async function copyText(text) {
  if (!text) return false;

  if (navigator.clipboard && window.isSecureContext) {
    try {
      await navigator.clipboard.writeText(text);
      return true;
    } catch {
      // Permission denied or a non-user-gesture call — try the fallback.
    }
  }

  try {
    const textarea = document.createElement("textarea");
    textarea.value = text;
    textarea.setAttribute("readonly", "");
    // Keep it off-screen but still selectable; iOS ignores display:none.
    textarea.style.position = "fixed";
    textarea.style.top = "-9999px";
    textarea.style.opacity = "0";
    document.body.appendChild(textarea);
    textarea.select();
    textarea.setSelectionRange(0, text.length);
    const ok = document.execCommand("copy");
    document.body.removeChild(textarea);
    return ok;
  } catch {
    return false;
  }
}

export default copyText;
